/**
 * @generated SignedSource<<2c4001264f767636c043d5fa01049a47>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateTicketingNotificationPrefsInput = {
  key: string;
  value: boolean;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type useUpdateTicketingNotificationPrefsMutation$variables = {
  input: UpdateTicketingNotificationPrefsInput;
};
export type useUpdateTicketingNotificationPrefsMutation$data = {
  readonly updateTicketingNotificationPrefs: {
    readonly clientMutationId: string | null;
    readonly user: {
      readonly id: string;
      readonly notificationPrefs: {
        readonly emailAssigned: boolean | null;
        readonly emailMentioned: boolean | null;
        readonly emailCustomerReplied: boolean | null;
        readonly emailWatching: boolean | null;
        readonly emailSlaBreached: boolean | null;
        readonly inAppAssigned: boolean | null;
        readonly inAppMentioned: boolean | null;
        readonly inAppCustomerReplied: boolean | null;
        readonly inAppWatching: boolean | null;
        readonly inAppSlaBreached: boolean | null;
      } | null;
    } | null;
  } | null;
};
export type useUpdateTicketingNotificationPrefsMutation = {
  variables: useUpdateTicketingNotificationPrefsMutation$variables;
  response: useUpdateTicketingNotificationPrefsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateTicketingNotificationPrefsPayload",
    "kind": "LinkedField",
    "name": "updateTicketingNotificationPrefs",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountUser",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationPrefs",
            "kind": "LinkedField",
            "name": "notificationPrefs",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailAssigned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailMentioned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailCustomerReplied",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailWatching",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailSlaBreached",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "inAppAssigned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "inAppMentioned",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "inAppCustomerReplied",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "inAppWatching",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "inAppSlaBreached",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateTicketingNotificationPrefsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUpdateTicketingNotificationPrefsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d710804e1606f08d0b25e1af708b257f",
    "id": null,
    "metadata": {},
    "name": "useUpdateTicketingNotificationPrefsMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateTicketingNotificationPrefsMutation(\n  $input: UpdateTicketingNotificationPrefsInput!\n) {\n  updateTicketingNotificationPrefs(input: $input) {\n    clientMutationId\n    user {\n      id\n      notificationPrefs {\n        emailAssigned\n        emailMentioned\n        emailCustomerReplied\n        emailWatching\n        emailSlaBreached\n        inAppAssigned\n        inAppMentioned\n        inAppCustomerReplied\n        inAppWatching\n        inAppSlaBreached\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "11935b0f522e7fd429950f6ce0359fba";

export default node;
